// extracted by mini-css-extract-plugin
module.exports = {"overlay":"BackgroundModelLoading_overlay__6LjDL","spinner":"BackgroundModelLoading_spinner__My6Xj"};